import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import CharacterSheetTop from './CharacterSheetTop.vue';
import CharacterSheetSection from './CharacterSheetSection.vue';
import { range } from 'lodash';
import { namespace } from 'vuex-class';
const characterModule = namespace('character');
let CharacterSheet = class CharacterSheet extends Vue {
    constructor() {
        super(...arguments);
        this.range = range;
        this.openTabs = [0, 1, 2];
    }
    get numSections() {
        return {
            xs: 1,
            sm: 2,
            md: 3,
            lg: 3,
            xl: 3
        }[this.$vuetify.breakpoint.name];
    }
    goToTab(newTab, section) {
        Vue.set(this.openTabs, section, newTab);
    }
};
__decorate([
    Prop(Object)
], CharacterSheet.prototype, "completeCharacter", void 0);
__decorate([
    Prop(Object)
], CharacterSheet.prototype, "rawCharacter", void 0);
__decorate([
    Prop(Object)
], CharacterSheet.prototype, "characterValidation", void 0);
__decorate([
    Prop(Boolean)
], CharacterSheet.prototype, "isDirty", void 0);
CharacterSheet = __decorate([
    Component({
        components: {
            CharacterSheetTop,
            CharacterSheetSection
        }
    })
], CharacterSheet);
export default CharacterSheet;
